import React from 'react'
import { Link } from 'react-router-dom'


export default function Garlic() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd6 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Garlic </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Garlic </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Garlic</h2>
        <h5 className='text-muted'> Egyptian Fresh Garlic is a flavorful and aromatic variety prized for its bold taste 
        and versatility in cooking traditional Middle Eastern and Mediterranean cuisines.
        </h5>
      </div>
      
      <div className="container-fluid bg-light bg-icon mb-5 py-5">
            <div className="container">
                <div className="section-header text-center mx-auto my-5 wow fadeInUp " data-wow-delay="0.1s" style={{ maxWidth: '500px' }}>
                    <h1 className="display-5  text-primary">Types of Garlic</h1>
                    <h4 className='text-secondary'>White / violet</h4>
                </div>
               
            </div>
        </div>
     
 
        <h2 className='text-primary my-3'>Packing</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>in 10 kgs carton or plastic

    </h5>
  </li>
</ul>

<hr />
<h2 className='text-primary my-3'>Season:</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> from February to April
    </h5>
  </li>


</ul>
<hr />
<hr />
<h2 className='text-primary my-3'>sizes:</h2>

<ul className='mb-5'>
  <li className="my-2">
    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> 12 mm: 22 mm
    </h5>
  </li>


</ul>
      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
